import { navigate } from 'gatsby';
import React, { FC } from 'react';

import { EmergencyContactsEditStep } from '@ui/routes/shared/EmergencyContactsEditStep';

import useMemberInfo from '@hooks/useMemberInfo';

import { IPageProps } from '@folx-types/flow-steps';

interface IEmergencyContactsEditStepPageProps extends IPageProps {}

const EmergencyContactsEditStepPage: FC<IEmergencyContactsEditStepPageProps> = ({
	path,
	...props
}) => {
	const { memberInfo } = useMemberInfo();

	const emergencyContact = props?.location?.state?.contact ?? {};

	const handleNavigate = () => navigate('..');

	return (
		<EmergencyContactsEditStep
			path={path}
			member={memberInfo}
			emergencyContact={emergencyContact}
			handleNavigate={handleNavigate}
			showCancel
		/>
	);
};

export default EmergencyContactsEditStepPage;
